import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateStreakImage: builder.query<ApiResponse<{ image: string; imageUrl: string }>, void>({
      query: () => ({
        url: `streak/generate-image`,
        method: 'GET',
      }),
    }),
    updateStreakCommitment: builder.mutation<ApiResponse, { commitmentDays: number }>({
      query: ({ commitmentDays }) => ({
        url: 'streak/commitment',
        method: 'PATCH',
        body: { commitmentDays },
      }),
    }),
  }),
});

export const { useGenerateStreakImageQuery, useUpdateStreakCommitmentMutation } = extendedApiSlice;
